<template>
  <div class="app-container">
    <div class="div-align-lr page-top-but">
        <el-button type="primary" icon="el-icon-plus" @click.native="handleForm(null,null)">新增维保团队</el-button>
        
        <div style="width=250px"><el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
                <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="团队id" value="team_number"></el-option>
                    <el-option label="团队名称" value="team"></el-option>
                    <el-option label="队长" value="realname"></el-option>
                    <el-option label="联系方式" value="tel"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
            </el-input></div>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" row-key="id" stripe style="width: 100%">
      <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
      <el-table-column align="center" prop="team_number" label="团队id" sortable> </el-table-column>
      <el-table-column align="center" prop="name" label="团队名称" sortable> </el-table-column>
      <el-table-column align="center" prop="area" label="负责区域" sortable> </el-table-column>
      <el-table-column align="center" prop="realname" label="队长" sortable> </el-table-column>
      <el-table-column align="center" prop="u_number" label="成员人数" sortable> </el-table-column>
      <el-table-column align="center" prop="p_number" label="项目数" sortable> </el-table-column>
      <el-table-column align="center" prop="tel" label="联系方式"> </el-table-column>

      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
        
    <div v-if="pageData.total > pageData.per_page" class="pageWrap">
        <el-pagination background layout="prev, pager, next" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <!--表单-->
    <el-dialog title="团队信息" :visible.sync="addTuserVisible" :before-close="hideAddTuser" :close-on-click-modal="false" width="1200px" top="5vh">
        <el-form :model="formData" :rules="addTuserRules" :inline="true" ref="dataForm" label-width="90px">
            <div class="">
                <el-form-item label="团队ID：" style="width:100%">
                    <div class="content">{{formData.team.team_number}}</div>
                </el-form-item>
                <el-form-item label="团队名称" prop="team.name" style="width:100%">
                    <el-input v-model="formData.team.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="负责区域" prop="team.area" style="width:100%">
                    <el-input v-model="formData.team.area" auto-complete="off"></el-input>
                </el-form-item>
            </div>

            <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
        
            <h3 class="el-dialog__title">队员配置</h3>
            
            
            <div class="addTuserItme" v-for="(item, index) in formData.user_arr" :key="index">
                <el-form-item label="名字" :prop="'user_arr.' + index + '.realname'" :rules="{required: true, message: '请输入队员名字', trigger: 'blur'}">
                    <el-input v-model="item.realname"></el-input>
                </el-form-item>
                <el-form-item label="身份" :prop="'user_arr.' + index + '.is_team'" :rules="{required: true, message: '请选择队员的身份', trigger: 'blur'}">
                    <el-select v-model="item.is_team" value-key="is_team" placeholder="请选择" style="width:100px">
                        <el-option label="队长" value="1"></el-option>
                        <el-option label="队员" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" :prop="'user_arr.' + index + '.tel'" :rules="{required: true, message: '请输入手机号码', trigger: 'blur'}">
                    <el-input v-model="item.tel" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" :prop="'user_arr.' + index + '.idcard'" :rules="{required: true, message: '请输入身份证号码', trigger: 'blur'}">
                    <el-input v-model="item.idcard" maxlength="18"></el-input>
                </el-form-item>
                <el-form-item v-if="index > 0">
                    <el-button type="text" @click.native="addTuserItmeDel(item, index)" icon="el-icon-close"></el-button>
                </el-form-item>
            </div>
            
            <div class="tUserBut">
                <el-button type="primary" @click.native="addTuserItme(null,null)" icon="el-icon-plus" plain>添加更多成员</el-button>
            </div>
            <div class="tUserBut">
                <el-button type="primary" @click.native="addTuserItmeFormSubmit()" style="width:200px">保 存</el-button>
            </div>
        </el-form>
    
    
    </el-dialog>
  </div>
</template>



<script>
    import {apiMaintainList,apiAddwTeam} from "../../api/views/maintain"
    const formDataUserJson = [{
        "realname":"",
        "is_team":"",
        "tel":"",
        "idcard":""
    }]
    export default {
        data () {
            return {
                query:{
                    id: "",
                },
                pageData: {
                    current_page: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 1
                },
                tableData: [],
                addTuserVisible: false,
                addTuserRules: {
                    team: {
                        name: [{ required: true, message: "请输入团队名称", trigger: "blur" }],
                        area:[{ required: true, message: "请输入团队管理区域", trigger: "blur" }]
                    },
                    user_arr:{
                        realname:[{ required: true, message: "请输入姓名", trigger: "blur" }],
                        is_team:[{ required: true, message: "请输入选择", trigger: "blur" }],
                        tel:[{ required: true, message: "请输入手机号", trigger: "blur" }],
                        idcard:[{ required: true, message: "请输入身份证号", trigger: "blur" }]
                    }
                },
                formData: {    
                    "team":{
                        "team_number": "",
                        "name": "",
                        "area": ""
                    },
                    "user_arr": []
                },
                searchPatrolSelectVal: '',
                searchPatrolVal: '',
            }
        },
        created:function() {
            this.getList({page: 1})
        },
        methods: {
            getList(page){
                apiMaintainList(page).then(res => {
                    console.log(res)
                    this.pageData = res
                    this.tableData = res.data
                    console.log(this.tableData)
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
            },
            // 点击查看
            handleClick(row) {
                // console.log(row);
                // console.log(row.id);
                this.query.id = row.id
                // console.log(this.query);
                this.$router.push({path:'/maintain/details',query:{id:row.id}});
            },
            // 显示表单
            handleForm(index, row) {
                this.addTuserVisible = true;
                this.formData.user_arr = Array.from(formDataUserJson)
                if (row !== null) this.formData = Object.assign({}, row)
                this.formData.team.team_number = 'WB' + Math.floor(Math.random() * (1000000 - 1)) + 1
                
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
                this.formData.user_arr[0].is_team = "1"
            },
            // 隐藏表单
            hideAddTuser() {
                // 更改值
                this.addTuserVisible = !this.addTuserVisible;
                this.$emit("onChange",this.addTuserVisible)
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.formData.user_arr = Array.from(formDataUserJson)
                return true;
            },
            handleCurrentChange: function(currentPage){
                this.getList({page:currentPage})
            },
            addTuserItme() {
                console.log(this.formData.user_arr)
                let formDataUserArr = this.formData.user_arr
                formDataUserArr.push({
                    idcard: "",
                    is_team: "0",
                    realname: "",
                    tel: ""
                })
            },
            addTuserItmeDel(item, index){
                this.formData.user_arr.splice(index, 1)
            },
            addTuserItmeFormSubmit(){
                const that = this
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let newObj = {}, data = {}, newFormData = JSON.parse(JSON.stringify(this.formData))
                        newFormData.user_arr.forEach((item,index) => {
                            newObj[index] = item
                        })
                        newFormData.user_arr = newObj
                        data = newFormData
                        apiAddwTeam(data).then(res => {
                            that.formLoading = false;
                            if (res.code == 0) {
                                that.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                // 刷新表单
                                that.$refs["dataForm"].resetFields();
                                that.hideAddTuser()
                                that.getList({page: 1})
                            } else {
                                that.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                    }
                })
            },
            onSearchPatrolBut(){
                console.log('搜索')
                this.query = {}
                this.query[this.searchPatrolSelectVal] = this.searchPatrolVal
                if(this.searchPatrolSelectVal && this.searchPatrolVal){
                    this.getList(this.query)
                }else if(!this.searchPatrolSelectVal){
                    this.$message({
                        message: '搜索类型不能为空',
                        type: "error"
                    })
                }else if(!this.searchPatrolVal){
                    this.$message({
                        message: '搜索内容不能为空',
                        type: "error"
                    })
                }
            },
        }
    }
</script>


<style lang="scss" scoped>  
  .app-container{
    color: #1f2f3d;
  }
  .app-container h2{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 28px;
  }
  .app-container h3{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 22px;
  }
  .app-container h3.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}
  .tUserBut{
      text-align: center;
      margin: 40px 0;
  }
  .pageWrap{
      padding: 30px 0;
      text-align: center;
  }
</style>
